import React, { useEffect ,useState } from "react";
import Sidebar from "../Components/Sidebar/Sidebar";
import { Link } from "react-router-dom";
import HeaderAdmin from "../Components/HeaderAdmin/Header";
import { getCurrentUser } from "../Api/auth";
import { addremotefittingapi } from "../Api/iron";
import Spinner from 'react-bootstrap/Spinner';

function Paynow() {


    const [userdata, setUserdata] = React.useState(null);
    const [user_id, setUser_id] = React.useState(0);
    const [apicall, setApicall] = useState(false);


    useEffect(() => {
        // setUserdata(getCurrentUser());
        const fetchUserData = async () => {
            try {
                const userData = await getCurrentUser();
                if (userData) {
                    setUserdata(userData);
                    setUser_id(userData.user._id);
                } else {
                    // Handle case where user data is missing or incomplete
                    console.error('User data is missing or incomplete.');
                }
            } catch (error) {
                // Handle any errors that occur during data fetching
                console.error('Error fetching user data:', error);
            }
        };

        fetchUserData();
    }, []);



    const addremotefitting = () => {

        setApicall(true);
        const data = {
            user_id: user_id,
            opencloseStatus : "open"
        }

        addremotefittingapi(data).then((response) => {
            if (!response.data.status) {
                alert(response.data.message);
            } else {
                const data = response.data.data;
                window.location.href = "/list-fitting"
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
        })
    }




    return (
        <div>
            <div className="main-page-body-content-header">
                <HeaderAdmin />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-lg-12">
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="box-content">
                                                <div className="succes d-flex gap-3  align-items-center ">
                                                    <div className="content-box-btn w-100">
                                                        <button className="btn btn-save w-100" onClick={addremotefitting}>
                                                            {apicall ? (<Spinner animation="border" className="border-black" />) : (<span> Accept</span>)}
                                                        </button>
                                                    </div>
                                                    <div className="content-box-btn w-100">
                                                        <Link to="/fitting">
                                                            <button className="btn btn-danger w-100">Decline</button>
                                                        </Link>
                                                        {/* <button className="btn btn-coming-soon">Decline</button> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
}

export default Paynow;